import React from 'react';
import './logo.css';

const logo = () => {
  return (
    <div>
      <a href="/" className="header__logo__icon">
        <span className="header__logo__text">SIMO</span>
      </a>
    </div>
  );
};

export default logo;
